var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreeInsideIconLonghaul(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .044h22.895v19.83H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M11.5 3a4.255 4.255 0 0 0-4.25 4.25 4.255 4.255 0 0 0 4.25 4.25 4.255 4.255 0 0 0 4.25-4.25A4.255 4.255 0 0 0 11.5 3m0 1.466a2.784 2.784 0 1 1 0 5.568 2.784 2.784 0 0 1 0-5.568"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M16.458 13.844l-.895 2.62-1.94-2.482a7.164 7.164 0 0 0 3.766-2.853l2.126 2.715h-3.057zm-3.91-1.148a5.706 5.706 0 0 1-2.196.004l-.067-.014A5.62 5.62 0 0 1 11.44 1.563a5.622 5.622 0 0 1 1.167 11.12c-.02.004-.04.01-.06.013zm-5.215 3.769l-.896-2.62H3.38l2.119-2.706a7.175 7.175 0 0 0 3.77 2.847l-1.936 2.479zm10.864-6.973c.25-.724.384-1.5.384-2.308 0-3.937-3.204-7.14-7.14-7.14C7.504.044 4.3 3.247 4.3 7.184c0 .812.137 1.593.387 2.321L0 15.49h5.26l1.498 4.383 4.34-5.557a7.51 7.51 0 0 0 .697 0l4.342 5.557 1.498-4.383h5.26l-4.698-5.998z",
    mask: "url(#b)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeInsideIconLonghaul);
export default __webpack_public_path__ + "static/media/free-inside-icon-longhaul.a427ed9dc7775bc4ed143f3604d0776f.svg";
export { ForwardRef as ReactComponent };